<template>
  <v-row>
    <v-col class="py-0 max-w-50px">
      <v-checkbox
        :class="{ 'mt-9': !noMargin }"
        class="mr-5"
        v-model="checkbox"
        :disabled="disabled"
        @change="onCheckboxClicked($event)"
      ></v-checkbox>
    </v-col>
    <v-col class="py-0">
      <paragraph class="mb-1"><slot></slot></paragraph>
      <v-select
        v-model="localVal"
        :items="items"
        :menu-props="{ bottom: true, offsetY: true }"
        append-icon="mdi-chevron-down"
        :label="label"
        :type="type"
        hide-details
        :disabled="!checkbox"
        :rules="rules"
      >
        <template slot="selection" slot-scope="data">
          {{ getItemName(data.item) }}
        </template>
        <template slot="item" slot-scope="data">
          {{ getItemName(data.item) }}
        </template>
      </v-select>
    </v-col>
  </v-row>
</template>

<script>
import Paragraph from "@/components/ui/Paragraph.vue";

export default {
  name: "SelectWithCheckbox",
  components: {
    Paragraph
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    getItemName: {
      type: Function,
      default: item => item
    },
    checked: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number],
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    label: {
      type: String,
      default: ""
    },
    noMargin: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checkbox: false,
      localVal: ""
    };
  },
  watch: {
    value(newVal) {
      this.localVal = newVal;
    },
    checked(newVal) {
      this.checkbox = newVal;
    },
    localVal(newVal) {
      this.localVal = newVal;
      this.$emit("update:value", newVal);
    }
  },
  methods: {
    onCheckboxClicked(val) {
      this.$emit("update:checked", val);
      if (!val) {
        this.$emit("update:value", "");
      }
    }
  }
};
</script>
